import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import InputField from '../../../components/Input-field/input-field.component';
import Button, { BUTTON_TYPE_CLASSES } from '../../../components/button/button.component';
import Alert, { ALERT_TYPE } from '../../../components/alert/alert.component';
import { useAuth } from '../../../Contexts/auth.context';
import { CMDiv, CMLink, BTN,MainDiv } from './login.styles';
import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { user_profile, user_login, loginOrRegister, getProfile, login_step_1, login_step_2, user_resendcode, user_loginGoogle, user_emailExisting, user_loginApple } from '../../../Services/prod/auth.service';
import moment from 'moment';
import 'moment-timezone';
import Heading from '../../../components/heading/heading.component';
import InputPassword from '../../../components/input-password/input-password.component';
import ForgotPasswordModal from '../../../components/forgot-password-modal/forgot-password-modal.component';
import { useNavigate } from 'react-router-dom';
import ConfirmLogin from '../login-confirm/login-confirm';
import { WelcomeModal } from '../signup/signup.styles';
import Image from '../../../components/image/image.component';
import { GoogleLogin } from '@react-oauth/google';
import { decodeJWT } from '../../../Utils/common.utils';
import AppleSignInButton from 'react-apple-signin-auth';
moment.tz.setDefault("EST");
const initialValues = {
  email: '',
  password: ''
}

function validateEmail(value) {
  let error;
  if (!value) {
    error = 'Required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    error = 'Invalid email address';
  }
  return error;
}
const loginSchema = Yup.object().shape({
  email: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),

  password: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
});



const Login = () => {
  const navigate = useNavigate();

  const { saveAuth, auth, setCurrentUser, saveAuthMapping } = useAuth();
  const location = useLocation();
  const [userStatus, setUserStatus] = useState({});
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [openVerify, setOpenVerify] = useState(false);
  const [openCode, setOpenCode] = useState(false);
  const [activeStep, setActiveStep] = useState(1);
  const [userProfile, setUserProfile] = useState([]);
  const [email, setEmail] = useState("");

  const queryParams = new URLSearchParams(location.search);
  const v2 = queryParams.get('v2');
  const divRef = useRef(null);
  useEffect(() => {

    if (location.state) {
      const { verified } = location.state;
      if (verified) {
        setUserStatus({ type: 'success', message: 'Please, login with your credentials.' });
        setTimeout(() => setUserStatus(null), 3000);
      }
    }
  }, [])

  const loginApple = async (idToken, hasError, firstName, lastName) => {
    const loginRes = await user_loginApple(idToken);
    const userData = decodeJWT(idToken);
    const searchParams = new URLSearchParams(location.search);
    const returnUrl = searchParams.get('returnUrl');
    if(loginRes && loginRes.isSuccess && userData.email) {
      try {
        const loginResponse = await loginOrRegister(userData.email, loginRes.user.userId,loginRes.user?.isInfluencer);
        saveAuthMapping(loginResponse?.data)
        const date = new moment(new Date()).add(3600, 's');
        const expiresAt = new Date(date).getTime();

        let tmpAuth = {
          ...loginRes.user,
          expiresAt: expiresAt,
        };
        try {
          const profileResponse = await user_profile(loginRes.user.userId);

          if (profileResponse) {
            const userProfile = profileResponse[0];

            tmpAuth = {
              ...tmpAuth,
              user_KYCstatus: userProfile.user_KYCstatus,
              user_FinancialStatus: userProfile.user_FinancialStatus,
              user_accounttype: userProfile.user_accounttype,
            };
          } else {
            console.log('There was an error fetching user profile information.');
          }
        } catch (error) {
          console.log('There was an error fetching user profile information.');
          console.error(error);
        }
        saveAuth(tmpAuth);
        setCurrentUser(tmpAuth.emailAddress);

        try {
          const profileRes = await getProfile();
          const kycStatus = profileRes?.data?.kyc_status;
          const encodedKycStatus = btoa(kycStatus);
          if (kycStatus) {
            localStorage.setItem('kycStatus', encodedKycStatus);
          }
        } catch (error) {
          console.error(error.message || "An error occurred In Token & Prifile Section");
        }
      } catch (e) {
        console.error(e);
      } finally {
        navigate(decodeURIComponent(returnUrl));
      }
    }
    else {
      if(hasError) {
        setUserStatus({ type: 'error', message: 'This account has been authorized on a different device. Remove Music Bull from your authorized apps and try again.' });
      } else {
        navigate('register?step=2', {state: {step: 2, useOauth: true, useApple: true, idToken: idToken, firstName: firstName, lastName: lastName}})
      }
    }
  }

  const loginGoogle = async (idToken) => {
    const loginRes = await user_loginGoogle(idToken);
    const userData = decodeJWT(idToken);
    const searchParams = new URLSearchParams(location.search);
    const returnUrl = searchParams.get('returnUrl');
    if(loginRes && loginRes.isSuccess && userData.email) {
      try {
        const loginResponse = await loginOrRegister(userData.email, loginRes.user.userId,loginRes.user?.isInfluencer);
        saveAuthMapping(loginResponse?.data)
        const date = new moment(new Date()).add(3600, 's');
        const expiresAt = new Date(date).getTime();

        let tmpAuth = {
          ...loginRes.user,
          expiresAt: expiresAt,
        };
        try {
          const profileResponse = await user_profile(loginRes.user.userId);

          if (profileResponse) {
            const userProfile = profileResponse[0];

            tmpAuth = {
              ...tmpAuth,
              user_KYCstatus: userProfile.user_KYCstatus,
              user_FinancialStatus: userProfile.user_FinancialStatus,
              user_accounttype: userProfile.user_accounttype,
            };
          } else {
            console.log('There was an error fetching user profile information.');
          }
        } catch (error) {
          console.log('There was an error fetching user profile information.');
          console.error(error);
        }
        saveAuth(tmpAuth);
        setCurrentUser(tmpAuth.emailAddress);

        try {
          const profileRes = await getProfile();
          const kycStatus = profileRes?.data?.kyc_status;
          const encodedKycStatus = btoa(kycStatus);
          if (kycStatus) {
            localStorage.setItem('kycStatus', encodedKycStatus);
          }
        } catch (error) {
          console.error(error.message || "An error occurred In Token & Prifile Section");
        }
      } catch (e) {
        console.error(e);
      } finally {
        navigate(decodeURIComponent(returnUrl));
        localStorage.removeItem(`appleuser_${userData.sub}`);
      }
    }
    else {
      navigate('register?step=2', {state: {step: 2, useOauth: true, idToken: idToken}})
    }
  }

  const onFacebook = async () => {
    
  }

  const onGoogle = async (response) => {
    let idToken = response?.credential;
    if(idToken) {
      await loginGoogle(idToken);
    }
  }

  const onApple = async (response) => {
    const {authorization, user} = response;
    const idToken = authorization.id_token;
    const payload = decodeJWT(idToken);
    
    // Apple only returns the user attribute the first time we authorize access to an account.
    if(user) {
      if(payload.sub) {
        localStorage.setItem(`appleuser_${payload.sub}`, JSON.stringify(user));
      }
      const {firstName, lastName} = user.name;
      if(authorization.id_token) {
        await loginApple(idToken, false, firstName, lastName);
      }
    }
    else {
      if(payload.sub) {
        const appleuser = JSON.parse(localStorage.getItem(`appleuser_${payload.sub}`));
        if(appleuser) {
          const {firstName, lastName} = appleuser.name;
          if(authorization.id_token) {
            await loginApple(idToken, false, firstName, lastName);
          }
        }
        else {
          if(authorization.id_token) {
            await loginApple(idToken, true, "", "");
          }
        }
      }
    }
  }

  const handleOpen = () => {
    setActiveStep(1);
    setOpen(true);
  }

  const handleCodeClose = () => {
    setOpenCode(false);
  }

  const handleCodeOpen = () => {
    setOpenCode(true);
  }

  const handleClose = () => {
    setActiveStep(2);
    setOpen(false);
  }

  const handleCloseVerify = () => {
    setOpenVerify(false);
  }

  const handleSubmit = async (values, { setStatus }) => {
    setLoading(true);
    const searchParams = new URLSearchParams(location.search);
    const returnUrl = searchParams.get('returnUrl');
    try {
      const loginResponse = await user_login(values.email, values.password);
      if (loginResponse && loginResponse.isSuccess) {
        setEmail(values.email);
        if(loginResponse?.emailVerified && (loginResponse?.emailVerified.toLowerCase() === "false" || loginResponse?.emailVerified === false)){
          sendAgain(values.email);
          setOpenVerify(true); 
        }else{
          const profileResponse = await user_profile(loginResponse.user.userId);
        if (profileResponse) {
          const userProfile = profileResponse[0];
          setUserProfile(userProfile);
          if (userProfile.Is2FAEnabled) {
            const loginResponse2 = await login_step_1(values.email, values.password);
            setCode(loginResponse2.user.key2FA);
            setOpenCode(true);
          } else {
            if (process.env.REACT_APP_ENVIRONMENT === 'app') {
              try {
              const userTokenId = loginResponse.user.userTokenId;
                if (!loginResponse || !loginResponse.user || !loginResponse.user.userTokenId) {
                console.error('Error: userTokenId is not available.');
                return;
                }
                if (typeof userTokenId !== 'string') {
                console.error('Error: userTokenId is not a valid string.');
                return;
                }
              
                const parts = userTokenId.split("-");
                if (parts.length === 0) {
                console.error('Error: userTokenId does not contain hyphens to split.');
                return;
                }
              
                const uid = parts.slice(-1)[0]; 
                if (!uid || typeof uid !== 'string') {
                console.error('Error: UID is invalid after splitting userTokenId.');
                return;
                }
              
                if (typeof window.dataLayer === 'undefined') {
                console.error('Error: window.dataLayer is not defined.');
                window.dataLayer = []; 
                }
              
                function gtag() {
                window.dataLayer.push(arguments);
                }
              
                gtag('config', 'G-4E3GQHG8ST', {
                user_id: uid,
                });
              } catch (error) {
                console.error('Unexpected error during Google Analytics configuration:', error);
              }
            }

            loginResponse.user['referral_code'] =loginResponse?.user.referral
            const res = await completeLoginWithout2FA(
              loginResponse,
              values.email,
              profileResponse
            );
            if (
              loginResponse?.user?.isInfluencer === "1" &&
              res?.data?.influencer_request === null
            ) {
              navigate("/influncer-enrollment");
            } else {
              navigate(decodeURIComponent(returnUrl));
            }
          }
        } else {
          setStatus('Error fetching user profile information.');
          setTimeout(() => setStatus(null), 3000);
        }
        }
      } else {
          setStatus(loginResponse.message || 'Error in the login process.');
          setTimeout(() => setStatus(null), 3000);
      }
    } catch (error) {
      setStatus('Error in the login process.');
      setTimeout(() => setStatus(null), 3000);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const completeLoginWithout2FA = async (loginResponse, email,profile) => {
    try {
      const loginRes = await loginOrRegister(email, loginResponse.user.userId,loginResponse.user?.isInfluencer,profile[0]?.user_firstname,profile[0]?.user_lastname, loginResponse.user?.referral_code);
      saveAuthMapping(loginRes?.data);

      const date = moment().add(loginResponse.user.expiresIn, 's');
      const expiresAt = date.valueOf(); // timestamp

      let tmpAuth = {
        ...loginResponse.user,
        expiresAt,
      };
      const profileRes = await getProfile();
      const profileResponse = await user_profile(loginResponse.user.userId);
      if (profileResponse) {
        localStorage.setItem('isInfluencerProfile',profileRes?.data?.influencer_request)
        const userProfile = profileResponse[0];
        tmpAuth = {
          ...tmpAuth,
          user_KYCstatus: userProfile.user_KYCstatus,
          user_FinancialStatus: userProfile.user_FinancialStatus,
          user_accounttype: userProfile.user_accounttype,
        };
        if(process.env.REACT_APP_ENVIRONMENT === 'app') {
          let pendo = window.pendo;
          pendo.initialize({
              visitor: {
                  id: loginResponse.user.userId,
                  email: loginResponse.user.emailAddress,
                  firstName: userProfile.user_firstname,
                  lastName: userProfile.user_lastname,
                  env: process.env.REACT_APP_ENVIRONMENT,
              },
              account: {
                  id: loginResponse.user.userId,
                  accountName: loginResponse.user.emailAddress,
                  kycStatus: userProfile.user_KYCstatus,
                  financialStatus: userProfile.user_FinancialStatus,
              }
          });
        }
      } else {
        throw new Error('Error fetching user profile information.');
      }

      saveAuth(tmpAuth);
      setCurrentUser(tmpAuth.emailAddress);
      const messageWelcome = localStorage.getItem('MessageWelcome');
      if (messageWelcome === null || messageWelcome === 'true') {
        localStorage.setItem('MessageWelcome', 'true');
      }

      const kycStatus = profileRes?.data?.kyc_status;
      if (kycStatus) {
        localStorage.setItem('kycStatus', btoa(kycStatus));
      }
      return loginRes;
    } catch (error) {
      console.error('Error in Token & Profile Section:', error.message || error);
      throw error;
    }
  };

  const sendAgain = (email) => {
    try {
      setUserStatus('');
      user_resendcode(email).then(data => {
        if (data && data.isSuccess === true) {
          setUserStatus("Email sent.");
          setTimeout(() => {
            setUserStatus('');
          }, 5000);
        }
      });
    } catch (error) {
      console.error(error);
    }
  }
  


  return (
    <MainDiv>
       <div className="App login_page">
      <Heading previusPage={'Login'} />
      <Formik
        initialValues={initialValues}
        validationSchema={loginSchema}
        onSubmit={handleSubmit}
      >

        {({ values ,errors, touched, status, setFieldValue,handleBlur }) => (
          <>
            <CMDiv className='login-form'>
              {status &&
                <Alert alertType={ALERT_TYPE.error}>{status}</Alert>
              }
              {userStatus?.message &&
                <Alert alertType={userStatus.type}>{userStatus.message}</Alert>
              }
              <span class="account-type">Account Type </span>
              <Form id='Login' className='mt-3' autoComplete='false'>
                <div className='form-container'>
                  <div className='inputGroup'>
                    <label>Email <span className='error-caption'>*</span></label>
                    <InputField
                      className='email-field form-control'
                      name='email'
                      id='email'
                      placeholder='Email'
                      isInvalid={errors.email}
                      validate={validateEmail}
                      error={errors.email}
                      onBlur={(e) => {
                        const trimmedValue = e.target.value.trim();
                        setFieldValue(e.target.name, trimmedValue);
                        handleBlur(e);
                      }} />
                  </div>
                  <div className='inputGroup'>
                    <label>Password <span className='error-caption'>*</span></label>
                    <div className='inputPassword'>
                      <InputPassword className='password-field form-control' name='password' id='password' placeholder='Password'
                        isInvalid={errors.password && touched.password}
                        error={errors.password} />
                    </div>
                  </div>
                  <BTN>
                  <Button type='submit' size="fullwidth" isProgressButton={true} progresscolor="#fff" loading={loading} disabled={loading}>Log In</Button>
                  </BTN>
                  <ConfirmLogin email={email} key2FA={code} open={openCode} handleClose={handleCodeClose} />
                  <Link to={''} onClick={handleOpen}>Forgot Password?</Link>
                  <div className="button-container">
                    <div className="google-button" style={{ width: "100%" }} ref={divRef}>
                      <GoogleLogin logo_alignment='center' onSuccess={onGoogle} style={{ width: "100%" }}  onError={(e) => console.error(e)} />  
                    </div> 
                    
                      <AppleSignInButton
                        authOptions={{
                          clientId: process.env.REACT_APP_APPLE_SERVICE_ID, // This is your service ID
                          scope: 'name email',
                          redirectURI: `https://${document.domain}`,
                          nonce: 'nonce',
                          usePopup: true, // important to catch up data on the frontend
                        }}
                        uiType="dark"
                        className="apple-auth-btn"
                        noDefaultStyle={false}
                        style={{width: "100%"}}
                        onSuccess={onApple}
                        onError={(error) => console.error(error)}
                      />
                    
                  </div>
                  <ForgotPasswordModal open={open} openStep={activeStep} handleClose={handleClose} />
                  <CMLink>
                    <p>Don't have an account?<Link to='register?step=1'> Sign up</Link></p>
                  </CMLink>

                  <WelcomeModal open={openVerify} onClose={handleCloseVerify}>
                  <div className='title'>
                    <Image src={'logo.png'} alt={'Music Bull'} width={150} />
                    <h2>Welcome to Musicbull!</h2>
                  </div>
                  {status && <Alert alertType={ALERT_TYPE.error}>{status}</Alert>}
                  {userStatus && <Alert alertType={ALERT_TYPE.success} style={{ paddingLeft: '10px' }}>{userStatus}</Alert>}
                  <div>
                    <p>Please, check your email: {values.email}<br />and activate your account by following the steps explained in the email.</p>
                    <p>If you don't see our email in your inbox, please check your spam folder</p>
                  </div>
                  <div className="button-container">
                    <Button buttonType={BUTTON_TYPE_CLASSES.OutlinedButton} color="blue" 
                    onClick={()=>{
                        navigate('/auth/confirm', { state: { email: values.email} })
                    }}>Received</Button>
                    <Button color="blue" onClick={()=>{sendAgain(values?.email)}}>Send again</Button>
                  </div>
                </WelcomeModal>
                </div>
              </Form>
            </CMDiv>
          </>
        )}

      </Formik>
    </div>
    </MainDiv>
   
  );
}

export default Login;